import { useContext } from 'react';

import { ContentContainerContext } from '../ContentContainerContextProvider';
import type { ContentContainerContextValue } from '../ContentContainerContextProvider.types';

export const useContentContainerContext = (): ContentContainerContextValue => useContext(ContentContainerContext);
